// Mock data for Luciana Belén MUAH Landing Page

export const siteInfo = {
  name: "LUCIANA BELÉN",
  tagline: "", // Removed tagline
  phone: "613151938",
  whatsapp: "34613151938",
  instagram: "https://www.instagram.com/lucianabelen_muah",
  instagramHandle: "@lucianabelen_muah",
  locations: ["Valencia"],
  country: "España"
};

export const heroContent = {
  title: "LUCIANA BELÉN",
  subtitle: "",
  description: "Maquillaje y Peinado especializado en novias y eventos. Acompaño a cada novia de manera personalizada para realzar su belleza natural.",
  cta: "Quiero más información"
};

export const aboutContent = {
  title: "Sobre mí",
  paragraphs: [
    "Soy Luciana Belén, maquilladora profesional formada en peinados de novias e invitadas, con más de 6 años de experiencia. Mi pasión es acompañarte para que te sientas auténtica, radiante y segura en uno de los días más especiales de tu vida.",
    "Creo en looks personalizados que reflejen tu estilo y resalten tu belleza natural. Mi compromiso es ofrecerte un acompañamiento cercano y totalmente adaptado a ti, porque cada novia merece sentirse especial y disfrutar ese gran día con tranquilidad."
  ],
  image: "https://customer-assets.emergentagent.com/job_36eb336e-7c60-473c-a3fd-4077fe4c217d/artifacts/oscpkdeu_PHOTO-2026-01-23-18-06-17.jpg"
};

export const services = [
  {
    id: "social",
    title: "Maquillaje Social",
    description: "Para eventos especiales, galas, graduaciones y cualquier ocasión donde quieras brillar.",
    features: [
      "Eventos y galas",
      "Graduaciones",
      "Sesiones fotográficas",
      "Ocasiones especiales"
    ],
    cta: "Quiero más información"
  },
  {
    id: "invitadas",
    title: "Madres e Invitadas",
    description: "Maquillaje y peinado profesional para madres de los novios, madrinas e invitadas especiales.",
    features: [
      "Madres de los novios",
      "Madrinas",
      "Invitadas especiales",
      "Look personalizado"
    ],
    cta: "Quiero más información"
  }
];

export const bridalContent = {
  sectionTitle: "Novias",
  title: "Tu día más especial",
  description: [
    "Tu boda es uno de los días más especiales de tu vida, y mi objetivo es que te sientas radiante, segura y auténtica. Trabajo de manera totalmente personalizada, adaptándome a tu estilo, tu vestido y al tipo de celebración que has soñado.",
    "Antes del gran día realizamos una sesión de prueba, donde exploramos juntas el look que mejor te representa. Escucho tus ideas, analizo tu piel y diseñamos un maquillaje y peinado que resalten tu belleza natural, manteniendo siempre tu esencia.",
    "Utilizo productos de alta gama y larga duración para garantizar un acabado impecable durante todo el día. Cada detalle cuenta: desde la elección de tonos hasta las técnicas que realzan lo que te hace única.",
    "El día de tu boda estaré a tu lado para que solo tengas que disfrutar. Me encargo de tu preparación, asegurándome de que te veas y te sientas espectacular, radiante y completamente tú."
  ],
  cta: "Quiero más información",
  image: "https://customer-assets.emergentagent.com/job_36eb336e-7c60-473c-a3fd-4077fe4c217d/artifacts/u8f7xn1z_PHOTO-2026-01-23-17-47-31.jpg"
};

export const specialMomentsContent = {
  title: "También para tus momentos especiales",
  description: "Invitadas, madrinas, bautizos, comuniones, aniversarios, cenas especiales, graduaciones y cualquier otro momento que quieras celebrar con un look especial. Ofrezco servicios profesionales adaptados a cada ocasión, cuidando la armonía entre tu estilo, tu outfit y el tipo de evento. Mi enfoque está en crear un look favorecedor, equilibrado y elegante, que potencie tus rasgos y te permita disfrutar de tu ocasión con total confianza y comodidad.",
  cta: "Quiero más información"
};

export const galleryImages = [
  {
    id: 1,
    src: "https://customer-assets.emergentagent.com/job_bridal-beauty-hub-2/artifacts/e87vpon3_Grok%20Image%202026-01-27%20at%2011.37.44%20p.%E2%80%AFm..png",
    alt: "Maquillaje profesional",
    category: "hero"
  },
  {
    id: 2,
    src: "https://customer-assets.emergentagent.com/job_36eb336e-7c60-473c-a3fd-4077fe4c217d/artifacts/u8f7xn1z_PHOTO-2026-01-23-17-47-31.jpg",
    alt: "Novia radiante",
    category: "novias"
  },
  {
    id: 3,
    src: "https://customer-assets.emergentagent.com/job_36eb336e-7c60-473c-a3fd-4077fe4c217d/artifacts/oscpkdeu_PHOTO-2026-01-23-18-06-17.jpg",
    alt: "Luciana Belén - Make Up Artist",
    category: "about"
  },
  {
    id: 4,
    src: "https://customer-assets.emergentagent.com/job_bridal-beauty-hub-2/artifacts/deng6cri_IMG_2656.JPG",
    alt: "Recogido elegante de novia",
    category: "peinados"
  },
  {
    id: 5,
    src: "https://customer-assets.emergentagent.com/job_bridal-beauty-hub-2/artifacts/z7nrwch5_IMG_2657.JPG",
    alt: "Peinado semi-recogido romántico",
    category: "peinados"
  },
  {
    id: 6,
    src: "https://customer-assets.emergentagent.com/job_bridal-beauty-hub-2/artifacts/gqk1r7lo_IMG_2662.jpg",
    alt: "Maquillaje y peinado novia",
    category: "novias"
  },
  {
    id: 7,
    src: "https://customer-assets.emergentagent.com/job_bridal-beauty-hub-2/artifacts/8kg779eh_IMG_2666.JPG",
    alt: "Sesión de maquillaje profesional",
    category: "social"
  },
  {
    id: 8,
    src: "https://customer-assets.emergentagent.com/job_bridal-beauty-hub-2/artifacts/k5nl3pko_IMG_2676.jpg",
    alt: "Ondas románticas peinado",
    category: "peinados"
  },
  {
    id: 9,
    src: "https://customer-assets.emergentagent.com/job_bridal-beauty-hub-2/artifacts/uo0ujdnf_IMG_2771.JPG",
    alt: "Maquillaje natural novia",
    category: "novias"
  },
  {
    id: 10,
    src: "https://customer-assets.emergentagent.com/job_bridal-beauty-hub-2/artifacts/umbgk2yz_IMG_2775.JPG",
    alt: "Look nupcial elegante",
    category: "novias"
  },
  {
    id: 11,
    src: "https://customer-assets.emergentagent.com/job_bridal-beauty-hub-2/artifacts/ytbd6dli_IMG_2790.JPG",
    alt: "Maquillaje profesional evento",
    category: "social"
  },
  {
    id: 12,
    src: "https://customer-assets.emergentagent.com/job_bridal-beauty-hub-2/artifacts/3obhzffx_IMG_2802.JPG",
    alt: "Peinado y maquillaje",
    category: "peinados"
  },
  {
    id: 13,
    src: "https://customer-assets.emergentagent.com/job_bridal-beauty-hub-2/artifacts/f49w85r9_IMG_2783.JPG",
    alt: "Novia maquillada",
    category: "novias"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Claudia",
    role: "Novia",
    text: "No puedo estar más contenta de haberte elegido. Mi hermana y yo hemos ido radiantes a la boda. Y has clavado nuestro estilo perfecto. Muchas gracias Luciana",
    rating: 5
  },
  {
    id: 2,
    name: "Ámparo",
    role: "Novia",
    text: "El maquillaje y peinado me han aguantado fenomenal. Eres muy profesional y has logrado interpretar el look justo para mi boda. Qué maravilla!",
    rating: 5
  },
  {
    id: 3,
    name: "Dolores",
    role: "Novia",
    text: "Gracias Luciana porque ni con el baile se ha movido nada. Estoy superfeliz de haber confiado en ti. Todos me han dicho lo guapa que estaba.",
    rating: 5
  }
];

export const contactInfo = {
  title: "Contáctame",
  subtitle: "Contáctame",
  description: "Si tienes alguna duda sobre mis servicios o quieres reservar tu fecha, estaré encantada de atenderte.",
  locations: "Madrid · Valencia",
  availability: "Servicio a domicilio disponible"
};

export const workProcessContent = {
  title: "Cómo trabajo",
  subtitle: "Mi proceso",
  steps: [
    {
      number: "01",
      title: "Reserva y primer encuentro",
      description: "Luego de reservar tu fecha, tendremos una charla donde hablamos de tu boda, tu estilo y lo que imaginas para ese día. Es un espacio para conocernos, intercambiar ideas y sentar las bases de un look que esté alineado con tu personalidad y tu esencia."
    },
    {
      number: "02",
      title: "Prueba de maquillaje y peinado",
      description: "Entre 6 y 4 semanas antes del gran día realizamos una sesión donde exploramos diferentes opciones hasta dar con el look que mejor te represente. Realizo una evaluación personalizada de tu piel para seleccionar los productos más adecuados y garantizar un resultado impecable y duradero. Ajustamos detalles, tonos y acabados para lograr una imagen armoniosa y fiel a lo que buscas."
    },
    {
      number: "03",
      title: "El gran día",
      description: "Me traslado al lugar donde te prepares para encargarme de tu maquillaje y peinado. Cuido cada detalle para que vivas la experiencia con calma, disfrutes del momento y tengas un servicio exclusivo. Te entregaré un kit de retoque para que tu maquillaje se mantenga perfecto durante todo el evento. Mi objetivo es que te veas y te sientas radiante, cómoda y tú misma."
    }
  ],
  image: "https://customer-assets.emergentagent.com/job_bridal-beauty-hub-2/artifacts/deng6cri_IMG_2656.JPG"
};
